import { createDatagridCallbackRegistry } from './datagridCallbacks';
import ajax from './ajax';
import createElement from '../components/create/element';

class Load {
  #resolveConfigKey(options = {}) {
    const candidate = String(options.configKey ?? options.key ?? '').trim();
    if (!candidate || candidate.startsWith('dic.')) {
      return 'main';
    }
    return candidate;
  }

  async #datagrid(options) {
    const actionRegistry = (
      globalThis?.__EP_DATAGRID_ACTION_REGISTRY
      && typeof globalThis.__EP_DATAGRID_ACTION_REGISTRY === 'object'
    )
      ? globalThis.__EP_DATAGRID_ACTION_REGISTRY
      : {};

    const service = options.service || options.category;
    const controlKey = [options.product, service, options.domain, options.module].join('.');
    const pageControls = globalThis?.__EP_DATAGRID_PAGE_CONTROLS?.[controlKey];
    const parent = document.querySelector('main');
    const pageControl = typeof pageControls?.mountBefore === 'function'
      ? await pageControls.mountBefore({ options, parent, createElement })
      : null;
    const component = await create({
      element: 'datagrid',
      parent: 'main',
      product: options.product,
      service: options.service || options.category,
      category: options.category,
      domain: options.domain,
      module: options.module,
      key: this.#resolveConfigKey(options),
      initialAction: options.initialAction,
      callbackRegistry: createDatagridCallbackRegistry(options),
      actionRegistry,
      rowTransform: pageControl?.transformRow,
    });
    if (typeof pageControls?.mountAfter === 'function') {
      await pageControls.mountAfter({ options, parent, component, pageControl });
    }
    return component;
  }

  /**
   * Módulo de formulário DIRETO (template `autoform`): abre o formulário do módulo em um Dialog sobre a tela atual, sem grade e SEM limpar `main`, carregando o registro único do
   * contexto (ex.: configuração do tenant). A configuração vem do `getConfigForm` do módulo (largura em `style`); salvar ou cancelar fecha o Dialog.
   */
  #autoform(options) {
    return create({
      element: 'autoform',
      id: `${options.module}-autoform`,
      parent: 'main',
      type: 'fieldset',
      product: options.product,
      service: options.service || options.category,
      category: options.category,
      domain: options.domain,
      module: options.module,
      key: this.#resolveConfigKey(options),
      mode: 'edit',
      singleton: true,
      isDialog: true,
      isDraggable: true,
      kill: true,
      dialog: {
        autoform: true,
        class: 'autoform-dialog',
      },
    });
  }

  #board(options) {
    create({
      element: 'board',
      parent: 'main',
      product: options.product,
      service: options.service || options.category,
      category: options.category,
      domain: options.domain,
      module: options.module,
      key: this.#resolveConfigKey(options),
    });
  }

  async #dashboard(options) {
    const response = await ajax.post({
      product: options.product,
      service: options.service || options.category,
      category: options.category,
      domain: options.domain,
      module: options.module,
      method: 'getPresentation',
      body: {
        key: this.#resolveConfigKey(options),
        presentation: 'dashboard',
      },
    });

    if (response?.status !== 'success' || !response?.config) {
      return response;
    }

    await create({
      ...response.config,
      element: 'dashboard',
      parent: 'main',
      product: options.product,
      service: options.service || options.category,
      category: options.category,
      domain: options.domain,
      module: options.module,
    });

    return response;
  }

  async component(options) {
    // Templates que abrem em Dialog (autoform) preservam o conteúdo de `main`.
    if (options.clear === true && options.template !== 'autoform') {
      document.querySelector('main')?.empty();
    }

    switch (options.template) {
      case 'datagrid':
        return this.#datagrid(options);
      case 'autoform':
        return this.#autoform(options);
      case 'board':
        this.#board(options);
        break;
      case 'dashboard':
        await this.#dashboard(options);
        break;
      default:
        break;
    }
  }
}

const load = new Load();
export default load;
